import { select } from '@redux-saga/core/effects'
import { Action } from 'infra/types'
import { IAppState } from 'infra/AppState'
import { Mixpanel } from 'services/Tracking/Mixpanel'
import { AuthStorageInstance } from 'services/Storage/AuthStorage'
import { getLanguage } from 'utils/getLanguage'
import { AuthActions } from './auth.actions'

export default function* authAnalytics(action: Action<any>): any {
  const state: IAppState = yield select((state: IAppState) => state)
  const merchantId =
    state.Dashboard.merchantProfile.data?.id || AuthStorageInstance.getCurrentBusinessId() || ''

  switch (action.type) {
    case AuthActions.AUTH_PAGE_LOADED:
      yield Mixpanel.trackWithPreset('View Onboarding Screen', {
        Flow: 'login',
        merchant_id: merchantId
      })
      break
    case AuthActions.ENTER_PHONE_NUMBER: {
      if (
        action.payload &&
        (action.payload.toString().length === 0 || action.payload.toString().length === 10)
      ) {
        yield Mixpanel.trackWithPreset('Mobile Number Entered', {
          Flow: 'login',
          merchant_id: merchantId
        })
      }
      break
    }
    case AuthActions.GET_OTP: {
      yield Mixpanel.trackWithPreset('Request OTP', {
        Flow: 'login',
        Type: 'Manual',
        Screen: 'Mobile Update/Mobile Screen',
        merchant_id: merchantId
      })
      break
    }
    case AuthActions.VERIFY_OTP: {
      yield Mixpanel.trackWithPreset('Login Started', {
        Flow: 'login',
        Type: 'Manual',
        merchant_id: merchantId
        // Mobile: action.payload.number
      })
      break
    }
    case AuthActions.OPEN_LANGUAGE_DROPDOWN: {
      yield Mixpanel.trackWithPreset('View Language', {
        Screen: action.payload,
        merchant_id: merchantId
      })
      break
    }
    case AuthActions.CHANGE_LANGUAGE: {
      yield Mixpanel.trackWithPreset('Select Language', {
        Screen: action.payload.screen,
        SetValue: getLanguage(action.payload.languageId).key,
        List: action.payload.screen === 'Settings Page' ? false : true,
        merchant_id: merchantId
      })
      if (action.payload.screen === 'Settings Page') {
        yield Mixpanel.trackWithPreset('LanguageSelectedInApp', {
          Screen: action.payload.screen,
          SetValue: getLanguage(action.payload.languageId).key,
          List: false,
          merchant_id: merchantId
        })
      }
      break
    }
    case AuthActions.CLICK_TERMS: {
      yield Mixpanel.trackWithPreset('View terms', {
        Flow: 'login',
        Type: 'Privacy/terms',
        merchant_id: merchantId
      })
      break
    }
    case AuthActions.CLICK_PRIVACY: {
      yield Mixpanel.trackWithPreset('View policy', {
        Flow: 'login',
        Type: 'Privacy/terms',
        merchant_id: merchantId
      })
      break
    }
    case AuthActions.EDIT_MOBILE: {
      yield Mixpanel.trackWithPreset('Edit Mobile', {
        Flow: 'login',
        Type: 'Manual',
        merchant_id: merchantId
        // Mobile: action.payload
      })
      break
    }
    case AuthActions.VERIFY_OTP_SUCCESS: {
      yield Mixpanel.trackWithPreset('Login Success', {
        Flow: 'login',
        Type: 'SMS',
        Register: action.payload.newUser,
        merchant_id: merchantId
      })
      if (action.payload.newUser) {
        yield Mixpanel.trackWithPreset('Register Successful', {
          Flow: 'login',
          Type: 'SMS',
          merchant_id: merchantId
        })
      }
      break
    }
    case AuthActions.VERIFY_OTP_FAILURE: {
      yield Mixpanel.trackWithPreset('OTP Error', {
        Flow: 'login',
        Reason: 'OTP Error',
        Type: 'Manual',
        merchant_id: merchantId
      })
      break
    }
    case AuthActions.OPEN_SIGNOUT_MODAL: {
      yield Mixpanel.trackWithPreset('Signout', {
        Screen: 'Drawer',
        merchant_id: merchantId
      })
      break
    }
    case AuthActions.SIGNOUT_FROM_ALL_DEVICES: {
      yield Mixpanel.trackWithPreset('Signout From All Devices Confirm', {
        Screen: 'Settings Page',
        merchant_id: merchantId
      })
      break
    }
    case AuthActions.SIGNOUT_FROM_ALL_DEVICES_CANCEL: {
      yield Mixpanel.trackWithPreset('Signout From All Devices Cancel', {
        merchant_id: merchantId
      })
      yield Mixpanel.reset()
      break
    }
    case AuthActions.SIGNOUT: {
      yield Mixpanel.trackWithPreset('Confirm Signout', {
        Screen: 'Drawer',
        Method: 'Button',
        merchant_id: merchantId
      })
      yield Mixpanel.reset()
      break
    }
    case AuthActions.SIGNOUT_CANCEL: {
      yield Mixpanel.trackWithPreset('Cancel Signout', {
        Screen: 'Drawer',
        Method: 'Button',
        merchant_id: merchantId
      })
      break
    }
    default: {
      return
    }
  }
  return
}
